export default "__VITE_ASSET__0222b7bf__"